// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___21e4935cbb0106d3d5a","cls2":"ImpactHubModal-cls2__faa0122aa6727864c141 ImpactHubModal-cls1___21e4935cbb0106d3d5a"};